import React, { useState, useEffect, useCallback } from 'react';
import DefaultLayout from '../layouts/DefaultLayout';
import { Helmet } from 'react-helmet';

import Row from 'react-bootstrap/Row';
import GroupItem from './Discover/groupItem';
import Container from 'react-bootstrap/Container';
// import SpotLight from './Discover/spotLight';
import Col from 'react-bootstrap/Col';
import Text from '../components/Text';
import { createUseStyles } from 'react-jss';
import TwigListing from './TwigListing';
import { SpotLight, Product, Category } from '../types';
import { getSpotLights, getDealsProducts, getCategoryDiscover } from '../services/DiscoverService';
import SpotLightCard from './Discover/spotLightCard';
import _ from 'lodash';
import Loader from '../components/Loader';
import { Link } from 'react-router-dom';
import { BsChevronDown } from "react-icons/bs";

import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';


// import withCaption from 'react-awesome-slider/dist/captioned';

import  'react-awesome-slider/dist/styles.css';

import { RouteProps } from 'react-router';
import { useDispatch } from 'react-redux';
import { pageTrack, track } from '../services/mixpanelService';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';


export interface DiscoverProps {
    history: any
}

const Discover: React.FC<DiscoverProps> = ({ history }) => {
    const AutoplaySlider = withAutoplay(AwesomeSlider);


    const [selectedTab, setSelectedTab] = useState('twigs');

    const [loadingDeals, setLoadingDeals] = useState(true);
    const [dealsProducts, setDealsProducts] = useState<Product[]>([]);

    const [loadingSpot, setLoadingSpot] = useState(true);
    const [featuredSpotlight, setFeaturedSpotlight] = useState<SpotLight[]>([]);
    const [spotlights, setSpotlights] = useState<SpotLight[]>([]);


    const [loadingCategory, setLoadingCategory] = useState(true);
    const [categories, setCategories] = useState<Category[]>([]);
    const dispatch = useDispatch();


    const goToLink = useCallback((e, link) => {
        e.preventDefault();
        history.push(link) //to open new page
        track("category_discover")
        track("view_item_list")
    }, [dispatch]);


  
    useEffect(() => {
        (async () => {
            // setLoadingTwigs(true);
            try {
                pageTrack("discover_screen")
                let tempSpotLight = await getSpotLights("NOT_FEATURED")
                let tempFeaturedSpotlight = await getSpotLights("FEATURED")
                setSpotlights(tempSpotLight)
                setFeaturedSpotlight(tempFeaturedSpotlight)
                setLoadingSpot(false)
                track("discover")

            } catch (e) { }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            // setLoadingTwigs(true);
            try {
                let tempCategory = await getCategoryDiscover()
                setCategories(tempCategory)
                console.log(categories)
                setLoadingCategory(false)
            } catch (e) { }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            // setLoadingTwigs(true);
            try {
                let tempDealsProducts = await getDealsProducts()
                setDealsProducts(tempDealsProducts)
                setLoadingDeals(false)
            } catch (e) { }
        })();
    }, []);

    const classes = useStyles();
    return (
        <>
            <DefaultLayout history={history}>
                <Helmet>
                    <title> Discover twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
                </Helmet>
                {/* <Row className={classes.nav}>
                    <Col xs={12} className={classes.subNav}>
                        <div className={classes.categoriesTab}>
                            <Text bold className={classes.categoriesTabText} as="span"> ALL catigories
                            <BsChevronDown className={classes.categoriesTabIcon}></BsChevronDown>
                                <div className={classes.allCategories}>
                                    <Row>
                                        <Col lg={2}>
                                            <ul className={classes.ulCategory}>
                                                <li>
                                                    <Text className={classes.oneCategory} as="span">
                                                        sdssd
                                                </Text>
                                                </li>
                                                <li>
                                                    <Text className={classes.oneCategory} as="span">
                                                        sdssd
                                                </Text>
                                                </li>
                                                <li>
                                                    <Text className={classes.oneCategory} as="span">
                                                        sdssd
                                                </Text>
                                                </li>
                                                <li>
                                                    <Text className={classes.oneCategory} as="span">
                                                        sdssd
                                                </Text>
                                                </li>
                                                <li>
                                                    <Text className={classes.oneCategory} as="span">
                                                        sdssd
                                                </Text>
                                                </li>
                                                <li>
                                                    <Text className={classes.oneCategory} as="span">
                                                        sdssd
                                                </Text>
                                                </li>


                                            </ul>
                                        </Col>
                                    </Row>
                                </div>
                            </Text>
                        </div>
                        <div className={classes.offerTab}>
                            <Text className={classes.offerTabText}> Offer</Text>
                            <div className={classes.spreter}></div>
                            <Text className={classes.tagText}>Offer</Text>
                            <Text className={classes.tagText}> Offer</Text>
                            <Text className={classes.tagText}> Offer</Text>
                        </div>

                    </Col>
                </Row>


                <Row>
                    <Col xs={12} className={classes.colTabs}>
                        <div className={classes.tabs}>
                            <div className={clsx(classes.oneTab, selectedTab == 'following' ? classes.oneTabActive : "")}
                                onClick={() =>
                                    setSelectedTab('following')
                                }
                            >
                                <Text as="span">Following</Text>
                                {
                                    selectedTab == 'following' ?
                                        <div className={classes.circleActive}></div>
                                        : null
                                }
                            </div>
                            <div className={clsx(classes.oneTab, selectedTab == 'forYou' ? classes.oneTabActive : "")}
                                onClick={() =>
                                    setSelectedTab('forYou')
                                }
                            >
                                <Text as="span">For You</Text>
                                {
                                    selectedTab == 'forYou' ?
                                        <div className={classes.circleActive}></div>
                                        : null
                                }

                            </div>
                            <div className={clsx(classes.oneTab, selectedTab == 'offer' ? classes.oneTabActive : "")}
                                onClick={() =>
                                    setSelectedTab('offer')
                                }
                            >
                                <Text as="span">Offer</Text>
                                {
                                    selectedTab == 'offer' ?
                                        <div className={classes.circleActive}></div>
                                        : null
                                }

                            </div>
                        </div>
                    </Col>
                </Row> */}

                <Container fluid>
                    <Row>
                        <AutoplaySlider
                            play={false}
                            bullets={false}
                            organicArrows={false}
                            buttonContentRight={<div className={classes.arrows}><FaArrowRight className={classes.arrowSvg}></FaArrowRight></div>}
                            buttonContentLeft={<div className={classes.arrows}><FaArrowLeft className={classes.arrowSvg}></FaArrowLeft></div>}
                            cancelOnInteraction={false} // should stop playing on user interaction
                            interval={1000}
                        >
                            {
                                featuredSpotlight.map((item, index) => (
                                    // <div data-src={item.photo} onClick={e=>{goToLink(e, "/search?" + item.parametar)}}
                                    // />
                                    <div className={classes.imgPx}>
                                        <img src={item.photo} className={classes.img} onClick={e=>{goToLink(e, "/search?" + item.parametar)}}/>
                                    </div>
                                ))
                            }  
                        </AutoplaySlider>
                    </Row>
                    <Row>
                        <GroupItem
                            trackName="discover_offer"
                            title="Offers"
                            viewAll={true}
                            href="/search?searchKey=&tab=offers"
                            responsive={[
                                {
                                    breakpoint: 1400,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 4,
                                        infinite: true,
                                    },
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 3,
                                        infinite: true,
                                    },
                                },
                                {
                                    breakpoint: 1000,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        initialSlide: 2,
                                    },
                                }, {
                                    breakpoint: 800,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        initialSlide: 1,
                                    },
                                }]}
                            type="product" loader={loadingDeals} list={dealsProducts} />
                    </Row>

                    <Row>
                        <Loader className={classes.loader} center loading={loadingSpot}>
                            {() => (
                                <>
                                    {
                                        spotlights.map((item) => (

                                            <Col xs={12} lg={6} key={item.id}>
                                                <SpotLightCard spotLight={item} />
                                            </Col>
                                        ))
                                    }
                                </>

                            )}
                        </Loader>
                    </Row>

                    <Row>
                        <Loader className={classes.loader} center loading={loadingCategory}>
                            {() => (
                                <>
                                    {
                                        categories.map((item) => (
                                            <Col xs={12} lg={6} key={item.id} >
                                                <a href={"search?searchKey=&categoryId=" + item.id}>
                                                    <div onClick={e => goToLink(e, "search?searchKey=&categoryId=" + item.id)}>

                                                        {/* <Link to={"Explorer?category_id=" + item.id}> */}
                                                        <Text bold as="span" className={classes.title}>{item.name}</Text>
                                                        {/* </Link> */}
                                                    </div>
                                                </a>
                                                <Row>
                                                    {item.Subcategory.map((subItem) => (
                                                        <Col xs={12} sm={6} key={subItem.id}>
                                                            <a href={"search?searchKey=&categoryId=" + item.id + "&subCategoryId=" + subItem.id}>

                                                                {/* <Link to={"Explorer?category_id=" + item.id + "&subCategory_id=" + subItem.id}> */}
                                                                <div className={classes.categoryCard} onClick={e => goToLink(e, "search?searchKey=&categoryId=" + item.id + "&subCategoryId=" + subItem.id)} style={{ backgroundImage: `linear-gradient(30deg, rgba(0,0,0,0.4990371148459384) 0%, rgba(255,255,255,0) 50%) , url(${subItem.photo})` }}>
                                                                    <Text as="span" color="white" className={classes.categoryCardTitle}>{subItem.name}</Text>
                                                                </div>
                                                            </a>
                                                            {/* </Link> */}
                                                        </Col>

                                                    ))
                                                    }
                                                </Row>
                                            </Col>
                                        ))
                                    }
                                </>
                            )}

                        </Loader>
                    </Row>
                </Container>
            </DefaultLayout>
        </>
    )
}


const useStyles = createUseStyles({
    title: {
        // margin: '15px 0px!important'
        "&:hover": {
            cursor: "pointer"
        }
    },
    loader: {
        minHeight: '400px',
    },
    
    imgPx:{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FBFBFB',
        position:'relative'
    },
    img:{
        height: 'auto',
        width: '100%',
        position:'absolute',
        top:'25px'
    },
    
    arrows: {
        width: "35px",
        height: "35px",
        position: "relative",
        borderRadius: "50%",
        backgroundColor: "gray",
    },
    arrowSvg: {
        position: "absolute",
        left: "8px",
        top: "8px",
        fontSize: "18px"
    },
    // captionSlider: {
    //     color: "white",
    //     zIndex: 10000,
    //     position: "relative",
    //     fontSize: "30px",
    //     padding: "15px",
    //     backgroundColor: "#00000070",
    //     margin: "0px auto"
    // },
    categoryCard: {
        height: "150px",
        position: "relative",
        borderRadius: "5px",
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        margin: '15px 0px',
        "&:hover": {
            cursor: "pointer"
        }
    },
    categoryCardTitle: {
        position: "absolute",
        bottom: "10px",
        left: "15px",
        // textShadow: "0px 0px 2px black"
    },
    nav: {
        backgroundColor: "white"
    },
    subNav: {
        display: "inherit",
        boxShadow: "1px 1px 10px #98989885"
    },
    offerTab: {
        display: "flex",
        width: "70%",
        padding: "0px 10px"
    },
    tagText: {
        padding: "10px 5px",
        width: "fit-content",
    },
    offerTabText: {
        padding: "10px 5px",
    },
    spreter: {
        width: "1.2px",
        margin: "13px 0px",
        boxShadow: "1px 0px 1px #8080804f, 0px 1px 1px #8080804f, -1px 0px 1px #8080804f, 0px -1px 1px #8080804f",
        backgroundColor: "#5d5d5d"
    },
    categoriesTab: {
        padding: "10px 10px",
    },
    "categoriesTabIcon": {
        marginInlineStart: "10px"
    },
    categoriesTabText: {
        padding: "10px 0px",
        width: "fit-content",
        "&:hover": {
            cursor: 'pointer'
        },
        "&:hover $allCategories": {
            display: "block"
        }
    },
    allCategories: {
        cursor: "default",
        position: "absolute",
        display: "none",
        left: "0px",
        top: "44px",
        width: "100%",
        backgroundColor: "white",
        maxHeight: "250px",
        zIndex: "1",
        padding: "10px 25px",
        "&:hover": {
            display: "block"
        }
    },
    oneCategory: {
        fontWeight: "400",
        "&:hover": {
            textDecoration: "underline",
            cursor: 'pointer',
        }
    },
    ulCategory: {
        padding: "0px 10px"
    },
    colTabs: {
        '@media (max-width: 520px)': {
            order: "2"
        }
    },
    tabs: {

        justifyContent: "center",
        display: "flex"
    },
    oneTab: {
        margin: "5px 15px",
        "&:hover": {
            cursor: 'pointer'
        }
    },
    oneTabActive: {
        fontWeight: 'bold'
    },
    circleActive: {
        width: '8px',
        height: '8px',
        backgroundColor: '#522583',
        borderRadius: '50%',
        margin: '0px auto'
    },
    // '@media (max-width: 500px)':{
    //     sliderContainer:{
    //         marginTop: '-20px',
    //     }
    // },
})
export default Discover;
function idx(idx: any, event: number): void {
    throw new Error('Function not implemented.');
}

